/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import Button from 'components/common/Button';
import TitleImg from 'static/main/title.png';

const Title = () => {
  const { mq } = useTheme();
  const titleStyle = css`
    background: #6079ff;
    height: 812px;
    display: flex;
    align-items: center;
    background-image: url(${TitleImg});
    background-size: 960px;
    background-repeat: no-repeat;
    background-position: right center;
    .title {
      padding-left: 128px;
      .text {
        color: #fff;
        font-size: 76px;
        line-height: 96px;
        font-weight: 600;
      }
      button {
        margin-top: 40px;
      }
    }
    ${mq.mobile} {
      height: 640px;
      padding-bottom: 84px;
      align-items: end;
      background-size: 125vw;
      background-repeat: no-repeat;
      background-position: top 8vw left -20vw;
      .title {
        padding-left: 32px;
        .text {
          font-size: 28px;
          line-height: 36px;
        }
        button {
          margin-top: 16px;
        }
      }
    }
  `;

  return (
    <div css={titleStyle}>
      <div className="title">
        <div className="text">
          상품 없이 쇼핑몰을 만들고
          <br />
          수익을 올리세요
        </div>
        <Button
          color="white"
          onClick={() =>
            window.open('https://partner.mallpie.kr/auth/login', '_blank')
          }
        >
          5분만에 몰 만들기
        </Button>
      </div>
    </div>
  );
};

export default Title;
